// file path: ../../api/csr/map.js
import api from "../api"
export const mapAPI = {
	async publishMap(id) {
		const response = await api.post("/proxy/publish", {id:id})
		console.log(response)  // Log the response for debugging
		if (response.status !== 200) {
			throw new Error(`HTTP error! Status: ${response.status}`)
		}

		const value = response.data
		if (!value || !value.data || !value.data.metadata || !value.data.metadata.publish) {
			throw new Error("Could not get response!")
		}

		if (value.data.error && value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		return value.data.metadata.publish["embed-codes"]["embed-method-responsive"]
	},

	async updateChart(uniqueCountryArray, uniqueCodesArray, cumulativeScoresArray, breakdownArray, id) {
		const response = await api.put("/proxy/update", {
			uniqueCountryArray: uniqueCountryArray,
			uniqueCodesArray: uniqueCodesArray,
			cumulativeScoresArray: cumulativeScoresArray,
			breakdownArray:breakdownArray,
			id:id
		})
		console.log(response)  // Log the response for debugging
		if (response.status !== 200 && response.status !== 204) {
			throw new Error(`HTTP error! Status: ${response.status}`)
		}
		return response.data.message
	},
}
